import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

interface ShareIconProps extends SvgIconProps {
  disabled?: boolean;
}

const ShareIcon = (props: ShareIconProps) => {
  const { className, disabled, ...otherProps } = props;
  const fillColor = disabled ? 'rgba(255, 255, 255, 0.38)' : 'white';

  return (
    <SvgIcon {...otherProps} className={className || ''} viewBox="0 0 14 15">
      <path
        d="M8.39453 1.45163C8.08008 1.59108 7.875 1.90553 7.875 2.25006V4.00006H4.8125C2.15469 4.00006 0 6.15475 0 8.81256C0 11.9106 2.22852 13.2942 2.73984 13.5731C2.8082 13.6114 2.88477 13.6251 2.96133 13.6251C3.25938 13.6251 3.5 13.3817 3.5 13.0864C3.5 12.8813 3.38242 12.6926 3.23203 12.5532C2.975 12.3098 2.625 11.8313 2.625 11.0001C2.625 9.55084 3.80078 8.37506 5.25 8.37506H7.875V10.1251C7.875 10.4696 8.07734 10.784 8.39453 10.9235C8.71172 11.063 9.07812 11.0055 9.33516 10.7758L13.7102 6.83834C13.8934 6.67155 14 6.43639 14 6.18756C14 5.93873 13.8961 5.70358 13.7102 5.53678L9.33516 1.59928C9.07812 1.36686 8.70898 1.30944 8.39453 1.45163Z"
        fill={fillColor}
      />
    </SvgIcon>
  );
};

export default ShareIcon;
